"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeWindowProperty = void 0;
// istanbul ignore file @preserve --No need to test mocking helpers
var changeWindowProperty = function(propertyKey, value) {
    Object.defineProperty(window, propertyKey, {
        writable: true,
        configurable: true,
        value: value
    });
};
exports.changeWindowProperty = changeWindowProperty; //# sourceMappingURL=changeWindowProperty.js.map
